import usePrivateAxios from '@/common/api/usePrivateAxios'
import {
  CardCurrentLimitsData,
  CardCurrentLimitsResponse,
} from '@/features/cardCurrentLimits/types/cardCurrentLimits.type'
import { useQuery, UseQueryResult } from '@tanstack/react-query'

type UseCardCurrentLimitsProps = {
  id?: string;
  product_id?: string;
  establishment_branch_id?: string;
}

export const useCardCurrentLimits: (props: UseCardCurrentLimitsProps) => UseQueryResult<CardCurrentLimitsData, unknown> = ({
  id,
  product_id,
  establishment_branch_id
}) => {
  const privateAxios = usePrivateAxios()

  return useQuery<CardCurrentLimitsResponse, unknown, CardCurrentLimitsData>({
    enabled: !!(id && product_id),
    queryKey: ['cardCurrentLimits', id, product_id, establishment_branch_id],
    queryFn: () => privateAxios.get(`/client/cards/${id}/current_limits`, { params: { product_id, establishment_branch_id } }),
    select: (data) => data?.data?.data,
    retry: false,
  })
}
